import template from "./account-not-found.html"

(function ($, ko) {
    ko.components.register('account-not-found', {
        template: template,
    });
})(jQuery, ko);